module.exports = __webpack_public_path__ + "static/media/issam-ben-ahmed.22d6148c.jpg";